
import {Reducer} from "redux";
import {ClientTopPageState} from "../store/client_top_page_state";
import {ClientTopPageAction, ClientTopPageActionType} from "../action/client_top_page_action";

const initialState: ClientTopPageState = {
    customers: [],
    occupationCounts: null,
    jobCareersWithCustomerID: [],
    clientBookmarks: [],
    isLoading: false,
}

const clientTopPageReducer: Reducer<ClientTopPageState> = (state = initialState, action: ClientTopPageAction): ClientTopPageState => {
    switch (action.type) {

        case ClientTopPageActionType.REQUEST_GET_CUSTOMERS: {
            return Object.assign({}, state, {
                isLoading: true,
            })
        }
        case ClientTopPageActionType.CALLBACK_GET_CUSTOMERS: {
            if(action.isSuccess) {
                return Object.assign({}, state, {
                    customers: action.item ? action.item.customers : [],
                    jobCareersWithCustomerID: action.item ? action.item.jobCareersWithCustomerID : [],
                    clientBookmarks: action.item ? action.item.clientBookmarks : [],
                    occupationCounts: action.item ? action.item.occupationCounts : null,
                    isLoading: false,
                })
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                })
            }
        }


        default:
            return state;
    }
}

export default clientTopPageReducer;


// WEBPACK FOOTER //
// ./src/presentation/reducer/client_top_page_reducer.ts